import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";

import To01 from "@/public/static/images/tool_01.png";
import To02 from "@/public/static/images/tool_02.png";
import To03 from "@/public/static/images/tool_03.png";
import To04 from "@/public/static/images/tool_04.png";
import To05 from "@/public/static/images/tool_05.png";

import To06 from "@/public/static/images/tool_06.png";
import To07 from "@/public/static/images/tool_07.png";
import To08 from "@/public/static/images/tool_08.png";
import To09 from "@/public/static/images/tool_09.png";

function training_tools() {
  const img: any = "/static/images/s-tool.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };
  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content tool-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>E-learning</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p className="mb-4">
                In the world of education, DX (Digital Transformation)
                requirement is also increasing. So, at ITP Asia, we support
                creating E-learning systems flexibly, from full-scratch
                development to using existing packages.
              </p>
              <p className="mb-4">
                In addition to the platform, we also implement both "platform"
                and "software", both "offline" and "online", such as arranging
                seminars, sending teachers to do assignments, filming and
                producing educational videos, and localizing the content to each
                language.
              </p>
              <ul className="mb-5">
                <li>Dealers and distributors training</li>
                <li>Employee training</li>
                <li>User installation support</li>
                <li>New product description</li>
                <li>Webinar</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center Me0-heading-spr mb-3">
              <h2 className="mb-3">
                ILet your employees develop the skills and knowledge needed to
                perform their jobs effectively.
                <br />
                With our E-Training Tools service, you can and save your
                training cost for today and also, in the future.
              </h2>
              <h1 className="lh-1">
                <span className="fw-bolder t-pink mb-3">
                  Why E-Training Tools?
                </span>{" "}
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center mt-3">
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <Image
                    loading="lazy"
                    src={To01}
                    alt="Convenience: Flexible and Scalable"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <h1 className="card-title mb-3">
                    <span className="fw-bolder t-pink ">
                      {" "}
                      Convenience:
                      <br />
                      Flexible{" "}
                    </span>
                    and<span className="fw-bolder t-pink "> Scalable</span>
                  </h1>
                  <p className="mt-3">
                    Instead of giving a face-to-face training every time that
                    will cause an unnecessary cost, E-training tools provide a
                    flexible and scalable way to train employees and dealers.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <Image
                    loading="lazy"
                    src={To02}
                    alt="Consistent Training"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <h1 className="card-title mb-3 lh-1">
                    <span className="fw-bolder t-pink ">Consistent</span>
                    <br />
                    Training
                  </h1>
                  <p className="mt-3">
                    E-training tools ensure that all employees and dealers
                    receive consistent training, which is crucial in maintaining
                    quality standards and compliance across the organization.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center mt-3">
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <Image
                    loading="lazy"
                    src={To03}
                    alt="Improve Performance"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <h1 className="card-title mb-3 lh-1">
                    <span className="fw-bolder t-pink ">Improve</span>
                    <br />
                    Performance
                  </h1>
                  <p className="mt-4">
                    Effective training tools can lead to improved employee and
                    dealer performance, resulting in increased productivity,
                    better customer service, and ultimately, higher revenue for
                    the business.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <Image
                    loading="lazy"
                    src={To04}
                    alt="Time-Efficient"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <h1 className="card-title mb-3 lh-1">
                    <span className="fw-bolder t-pink ">Time</span>
                    -Efficient
                  </h1>
                  <p className="mt-4">
                    E-training tools allow employees and dealers to complete
                    their training at their own pace and on their own schedule.
                    This flexibility saves time and allows them to focus on
                    their work while still acquiring the necessary skills and
                    knowledge.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <Image
                    loading="lazy"
                    src={To05}
                    alt="Cost-Effective"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <h1 className="card-title mb-3 lh-1">
                    <span className="fw-bolder t-pink ">Cost</span>
                    -Effective
                  </h1>
                  <p className="mt-4">
                    Design can also be used to communicate complex information
                    in an easily digestible format. With design, you can
                    simplify complex data and make it more engaging for your
                    customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-12 text-center Me0-heading-spr">
              <h1 className="lh-1">
                <span className="fw-bolder t-pink mb-3">
                  Make your training process easier with ITP Asia
                </span>{" "}
              </h1>
              <h2 className="mb-3">
                we support training tools production From any of your existing
                platform to the full-scratch development
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex box-media box-tool text-start justify-content-left align-items-center">
                <div className="num-tool">
                  <span>1</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-pink">UNDERSTAND</span> your
                  needs
                </h2>
                <div className="tool-list t-white ">
                  <ul>
                    <li>Your goals & your objectives</li>
                    <li>Your current position and situation</li>
                    <li>Propose solutions</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-tool text-start justify-content-left  align-items-center">
                <div className="num-tool">
                  <span>2</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-pink">PLAN</span> the project
                </h2>
                <div className="tool-list t-white ">
                  <ul>
                    <li>Leadtime Estimation</li>
                    <li>Research & Ideation</li>
                    <li>Concept Determination</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-tool text-start justify-content-left  align-items-center">
                <div className="num-tool">
                  <span>3</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-pink">PRODUCE</span> the Material
                </h2>
                <div className="tool-list t-white ">
                  <ul>
                    <li>Lesson Planning & Content Creation</li>
                    <li>Photo & Video Shooting</li>
                    <li>Content Translation & Localization</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-tool text-start justify-content-left  align-items-center">
                <div className="num-tool">
                  <span>4</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-pink">PREPARE </span> the
                  Platform
                </h2>
                <div className="tool-list t-white ">
                  <ul>
                    <li>Platform based UX/UI Design</li>
                    <li>Learning Management System</li>
                    <li>Testing, Fixing, Quality Controlling</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-tool text-start justify-content-left  align-items-center">
                <div className="num-tool">
                  <span>5</span>
                </div>
                <h2 className="mb-0 t-white">
                  Ready to<span className="fw-bolder t-pink"> LAUNCH! </span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-12 text-center Me0-heading-spr">
              <h1 className="lh-1 t-white">
                At ITP Asia, we pay attention to each step of every single
                project with Omotenashi spirit.
              </h1>
              <h2 className="t-white">
                By creating Training Tools, we understand your needs and
                limitations, empathize Training Tools users, and perform our
                best to deliver the outcome that will release your
                organization’s burden of training so you can focus on growing
                your business.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center Me0-heading-spr mb-3">
              <h1 className="lh-1 mb-0">
                <span className="fw-bolder t-pink mb-3">
                  Curious of what we can do?
                </span>{" "}
              </h1>
              <h2 className="mb-3">
                Here are examples of our work that may spark your ideas
              </h2>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={To06}
                  alt="Dealers and Distributors Training"
                  className="img-fluid mx-auto px-5 w-75"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-pink mb-4 lh-1">
                    Dealers and Distributors Training
                  </h1>
                  <h4 className="mb-4">
                    Dealers and distributors play a crucial role in the business
                    as they are the ones who reach out to customers and promote
                    products or services. Providing them necessary knowledge and
                    skills is an important key to their effective performance.
                  </h4>
                  <h4 className="mb-4">
                    With E-Training tools, you can train your dealers and
                    distributors in a more convenient and efficient way.
                    Moreover, E-Training tools can help you save time and money
                    by eliminating the need for in-person training sessions or
                    travel expenses.
                  </h4>
                  <h4 className="mb-4">
                    Contact us today to learn more about how we can help make
                    your E-training process easier.
                  </h4>
                </div>
                <div className="card-footer t-white"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body t-white">
                  <h1 className="t-pink mb-4 lh-1">Employee Training</h1>
                  <h4 className="mb-4">
                    In today's fast-paced and ever-changing business world, it
                    is essential that your employees are equipped with the
                    necessary skills and knowledge to stay competitive and
                    succeed in their roles. That's where E-training tools come
                    in.
                  </h4>
                  <h4 className="mb-4">
                    By providing access to a wide range of online training
                    courses and resources, employees can quickly and easily
                    learn new skills, stay up-to-date with industry trends, and
                    improve their job performance. E-training tools not only
                    save time and money compared to traditional in-person
                    training, but they also offer the flexibility to learn at
                    their own pace and on their own schedule.
                  </h4>
                  <h4 className="mb-4">
                    Contact us today to learn more about how we can empower your
                    team to succeed through E-Training Tools.
                  </h4>
                </div>
                <div className="card-footer t-white"></div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={To07}
                  alt="Employee Training"
                  className="img-fluid mx-auto px-5 w-75"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={To08}
                  alt="Product Installation User Support"
                  className="img-fluid mx-auto px-5 w-75"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-pink mb-4 lh-1">
                    Product Installation User Support
                  </h1>
                  <h4 className="mb-4">
                    An installation manual is a critical guide for users to
                    ensure that they can properly install and operate the
                    product, without encountering any problems. However, with
                    the advancement of technology, providing E-Training Tools
                    has become a more efficient and effective approach for
                    businesses.
                  </h4>
                  <h4 className="mb-4">
                    Through these tools, you can ensure that your customers have
                    access to the installation manual at any time, leading to a
                    positive customer experience with the product. This can
                    result in increased customer satisfaction, brand loyalty,
                    and positive reviews. In addition, by providing clear and
                    concise installation instructions, users are more likely to
                    install the product correctly, which can improve its
                    performance, durability, and reduce the risk of returns.
                  </h4>
                  <h4 className="mb-4">
                    Take the first step towards creating an exceptional user
                    experience by partnering with us to develop tailored Product
                    Installation E-Manuals today.
                  </h4>
                </div>
                <div className="card-footer t-white"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body t-white">
                  <h1 className="t-pink mb-4 lh-1">New Product Introduction</h1>
                  <h4 className="mb-4">
                    When introducing a new product, a traditional in-person
                    training sessions can be time-consuming and costly. That's
                    where E-training tools come in.
                  </h4>
                  <h4 className="mb-4">
                    With our E-training tools, your employees and dealers can
                    learn about the product features, understand the target
                    market, and develop effective sales strategies at their own
                    pace and from any location. These tools offer flexibility
                    and convenience, allowing your team to access the
                    information they need when they need it.
                  </h4>
                  <h4 className="mb-4">
                    Say goodbye to the hassle of booking in-person training
                    sessions every time you launch a new product. Contact us
                    today to learn more about how we can support your business.
                  </h4>
                </div>
                <div className="card-footer t-white"></div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={To09}
                  alt="New Product Introduction"
                  className="img-fluid mx-auto px-5 w-75"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content pink-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h2 className=" fw-bolder">
                Still not sure where to start? Just drop us your contact!
              </h2>
              <h2>We can’t wait to reach you!</h2>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default training_tools;
